<template>
  <div class="teachers" v-title data-title="卓考网校|卓考名师介绍">
    <header class="g-header-container">
      <c-header title="卓考名师" />
    </header>
    <main class="g-view-container">
      <template v-for="(item, index) in teachers">
        <router-link
          class="item"
          :key="index"
          :to="`/teacher/${item.teacherId}`"
        >
          <teacher-item
            :avatar="item.photoUrl"
            :name="item.nickname"
            :jobs="item.tag"
          />
        </router-link>
      </template>
    </main>
    <footer class="g-footer-container">
      <c-tabbar />
    </footer>
  </div>
</template>

<script>
  import axios from 'axios';
  import CHeader from 'components/header';
  import CTabbar from 'components/tabbar';
  import TeacherItem from './item';

  export default {
    name: 'Teachers',
    components: {
      CHeader,
      CTabbar,
      TeacherItem,
    },
    data() {
      return {
        teachers: {},
      };
    },
    created() {
      axios
        .get('https://api.zhuokao360.com/teacher/findAll?type=10')
        .then(({ data: { code, data } }) => {
          if (code === 200) {
            this.teachers = data;
          }
        });
    },
  };
</script>

<style lang="scss" scoped>
@import "~assets/scss/mixins";

.g-view-container {
  @include flex-between();
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: flex-start;

  .item {
    margin: 20px 2.5% 0;
    width: 45%;
    min-width: 144px;
    max-width: 180px;
  }
}
</style>
